export const getWorkspaceId = (workspace = {}) => {
    return workspace?.['workspace.id'] || workspace?.id || '';
};
